import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {ThemeProvider, CssBaseline} from '@mui/material';
import { useThemeSwitcher } from '@signanthealth/modular-ui';

import AppLayout from './components/AppLayout';
import ProtocolList from './pages/ProtocolList';
import ProtocolDetail from './pages/ProtocolDetail';
import ProtocolGeneratorWizardPage from './pages/ProtocolGeneratorWizardPage';
import ProtocolWorkspacePage from './pages/ProtocolWorkspacePage';
import KBAdminPage from './pages/KBAdminPage';
import { SecurityWrapper } from './components/SecurityWrapper';
import { LoginCallbackRoute } from './components/LoginCallback';
import { oktaAuth } from './services/oktaAuth';
import { config } from './config';
import { getTheme } from './utils/theme';

// modular-ui base styles (matches study-management-client standard)
import '@signanthealth/modular-ui/styles/normalize.css';
import '@signanthealth/modular-ui/styles/base.css';
import '@signanthealth/modular-ui/styles/fontawesome.css';
import '@signanthealth/modular-ui/styles/fontawesome-solid.css';
import '@signanthealth/modular-ui/styles/fontawesome-regular.css';

function App() {
  // Use modular-ui theme switcher (helixLight / helixDark)
  // Pass ENV theme name to lock a specific theme, or null to allow toggle
  const { theme: fallbackTheme, toggleTheme } = useThemeSwitcher();
  const theme = getTheme(config.themeName, fallbackTheme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <SecurityWrapper
          oktaAuth={oktaAuth}
          applicationPath={config.applicationPath}
          enableGlobalLogout={true}
        >
          <Routes>
            <Route path="/login/callback" element={<LoginCallbackRoute />} />
            <Route path="/" element={<AppLayout toggleTheme={toggleTheme} />}>
              <Route index element={<ProtocolList />} />
              <Route path="protocol/:trialId" element={<ProtocolDetail />} />
              <Route path="protocol/:trialId/prs/:version" element={<ProtocolDetail />} />
              <Route path="wizard/:trialId/:version/:platform/*" element={<ProtocolGeneratorWizardPage />} />
              <Route path="workspace/:trialId/:sessionId/:platform" element={<ProtocolWorkspacePage />} />
              <Route path="admin/kb" element={<KBAdminPage />} />
            </Route>
          </Routes>
        </SecurityWrapper>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
